import { createAction } from 'redux-actions';
import NovasolApi from '../api/index';
import * as types from '../constants/ActionTypes';

export const initFromDrupal = createAction(types.INIT_FROM_DRUPAL);

export const initFromCookies = createAction(
  types.INIT_FROM_COOKIES,
  cookieParams => cookieParams
);

export const updateFromBackend = createAction(
  types.UPDATE_FROM_BACKEND,
  newState => newState
);

export const addSecurityPackageLink = createAction(
  types.ADD_SECURITY_PACKAGE_LINK
);

export const updateAgencyMessage = createAction(types.UPDATE_AGENCY_MESSAGE);

export const updateAgencySubId = createAction(types.UPDATE_AGENCY_SUB_ID);

export const updateOrderType = createAction(types.UPDATE_ORDER_TYPE);

export const updateAgencyUserId = createAction(types.UPDATE_AGENCY_USER_ID);

export const receiveFromBackend = createAction(types.RECEIVE_FROM_BACKEND);

export const selectPaymentType = createAction(types.SELECT_PAYMENT_TYPE);

export const selectPaymentOption = createAction(types.SELECT_PAYMENT_OPTION);

export const updateGuests = createAction(
  types.UPDATE_GUEST_OPTIONS,
  (propertyName, value) => ({ propertyName, value })
);

export const updateAdditionalChildren = createAction(
  types.UPDATE_ADDITIONAL_CHILDREN
);

export const updateCustomerInfo = createAction(
  types.UPDATE_CUSTOMER_INFO,
  (propertyName, value) => ({ propertyName, value })
);

export const updateCustomerDialCode = createAction(
  types.UPDATE_CUSTOMER_DIALCODE,
  (propertyName, value) => ({ propertyName, value })
);

export const updateCustomerPhone = createAction(
  types.UPDATE_CUSTOMER_PHONE,
  (propertyName, value) => ({ propertyName, value })
);

export const updateExtraServices = createAction(
  types.UPDATE_EXTRA_SERVICES,
  (serviceId, value) => ({ serviceId, value })
);

export const updateTickets = createAction(
  types.UPDATE_TICKETS,
  (serviceId, value) => ({ serviceId, value })
);

export const updateGuestsOptions = createAction(
  types.UPDATE_GUEST_OPTIONS,
  propertyName => ({ propertyName })
);

export const updateAgencyNumber = createAction(types.UPDATE_AGENCY_NUMBER);

export const updateSalesChannel = createAction(types.UPDATE_SALES_CHANNEL);

export const updateVoucherFromBackend = createAction(
  types.UPDATE_VOUCHER_BACKEND
);

export const updateVoucherCode = createAction(types.UPDATE_VOUCHER_CODE);

export const interactCustomerInfo = createAction(types.INTERACT_CUSTOMER_INFO);
export const sendAbandonBasket = createAction(types.SEND_ABANDON_BASKET);

export function validateVoucher(order) {
  return dispatch => {
    dispatch(receiveFromBackend());
    return NovasolApi.validateVoucherBackend(order,
      dispatch);
  };
}

export const pay = order => dispatch => NovasolApi.submitOrder(order,
  dispatch);

export const requestFromBackend = order => dispatch => {
  dispatch(receiveFromBackend());
  // Catch reject, handle in error reducer.
  return NovasolApi.postOrder(order,
    dispatch).catch(() => {});
};

export const submitAbandonBasket = order => dispatch => {
  dispatch(sendAbandonBasket(order));
  NovasolApi.sendAbandonBasket(order,
    dispatch);
};
